<template>
  <div>
    <div
      class="root"
      v-show="
        open &&
          CheckUserPermission([1, 2, 3, 4, 5, 6, 12]) &&
          queryObject.hasOwnProperty('dup')
      "
    >
      <div class="top-check-div">
        <label class="multi-check-label" for="check-all">
          <input
            type="checkbox"
            class="multi-check"
            @click="checkSelectAll"
            :checked="selectAll"
            id="check-all"
          />
          All
        </label>
        <label class="multi-check-label" for="exclude">
          <input type="checkbox" class="multi-check" id="exclude" />
          Exclusion</label
        >
        <!--        <label class="multi-check-label" for="exclude_tag">
                          <input
                            type="checkbox"
                            v-model="exclude_tag"
                            class="multi-check"
                            id="exclude_tag"
                          />
                          Exclude DUP
                        </label>-->
      </div>
      <!--
            <input
              class="input-main"
              type="search"
              placeholder="No Answered To"
              v-model="searchTagQuery"
            />
      -->

      <ul class="nav nav-tabs ">
        <li
          v-for="tab in dupMsTabs"
          :key="tab.id"
          :class="{ active: selectedDupMsTab === tab.alias }"
        >
          <a href="javascript:void(0)" @click="selectedDupMsTab = tab.alias">
            {{ tab.name }}
          </a>
        </li>
      </ul>
      <!--
                  v-on:scroll="fetchUsersStats"
            -->
      <div class="scroller-div" v-if="selectedDupMsTab === 'USERS'">
        <div v-show="showResults">
          <ul>
            <li v-for="(opt, idx) in result" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedUsers"
                  :value="opt.user"
                  :id="opt.id"
                />
                {{ opt.full_name
                }}<span class="item-counter"> {{ opt.count }}</span></label
              >
            </li>
          </ul>
        </div>
        <div v-show="!showResults">
          <ul>
            <li v-for="(opt, idx) in dupUsersStats" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedUsers"
                  :value="opt.user"
                  :id="opt"
                />
                {{ opt.user.full_name
                }}<span class="item-counter"> {{ opt.count }}</span></label
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="scroller-div" v-show="selectedDupMsTab === 'NA'">
        <div>
          <ul>
            <li v-for="(opt, idx) in naStatuses" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedNa"
                  :value="opt"
                  :id="opt.id"
                />
                {{ opt.name
                }}<span class="item-counter"> {{ dupNaStats }}</span></label
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="scroller-div" v-show="selectedDupMsTab === 'NI'">
        <div>
          <ul>
            <li v-for="(opt, idx) in niFilterOptions()" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedNi"
                  :value="opt"
                  :id="opt.id"
                />
                {{ opt.name
                }}<span class="item-counter">
                  {{ getNiStats(opt.id).count }}</span
                ></label
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="scroller-div" v-show="selectedDupMsTab === 'BN'">
        <div>
          <ul>
            <li v-for="(opt, idx) in bnFilterOptions()" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedBn"
                  :value="opt"
                  :id="opt.id"
                />
                {{ opt.name
                }}<span class="item-counter">
                  {{ getBnStats(opt.id).count }}</span
                ></label
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="scroller-div" v-show="selectedDupMsTab === 'NAAR'">
        <div>
          <ul>
            <li v-for="(opt, idx) in dupNAARStats" :key="idx">
              <label class="multi-check-label" :for="opt.id">
                <input
                  type="checkbox"
                  class="multi-check"
                  v-model="selectedNAAR"
                  :value="opt.user"
                  :id="opt.user_id"
                />
                {{ opt.user.full_name
                }}<span class="item-counter"> {{ opt.count }}</span></label
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="tag-form-btns">
        <a
          class="tag-form-cancel-btn"
          href="javascript:void(0)"
          @click.prevent="closeSelect"
          ><span class="fas fa-times"></span
        ></a>
        <div
          class="loader-bottom"
          v-if="
            requestDupUsersBusy ||
              requestDupNAARBusy ||
              requestDupBnBusy ||
              requestDupNaBusy ||
              requestDupNiBusy
          "
        >
          <loader :size="'3px'"></loader>
        </div>
        <button v-else class="bttn-tab" @click="applyFilter">
          APPLY
        </button>
        <a
          class="tag-form-ok-btn"
          href="javascript:void(0)"
          @click.prevent="resetSelect"
          ><span class="fas fa-sync"></span
        ></a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import apiClientCreator from "../../../../../../helpers/api/request";
import Loader from "../../../../../../main/misc.main/loader/Loader";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "MultiSelect.component",
  components: { Loader },
  mixins: [UsersPermissionCheck],
  props: {
    open: {
      type: Boolean,
      required: true
    },
    /*    options: {
              type: Array,
              required: true,
              default: () => []
            },*/
    resetList: {
      type: Boolean,
      required: false
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    queryObject: {
      type: Object
    }
  },
  data() {
    return {
      selectedUsers: [],
      selectedNa: [],
      selectedNi: [],
      selectedBn: [],
      selectedNAAR: [],
      infoData: [],
      openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      selectAll: false,
      dupUsersStats: [],

      dupNaStats: null,
      dupBnStats: [],
      dupNiStats: [],
      dupNAARStats: [],

      requestDupNAARBusy: false,
      requestDupUsersBusy: false,
      requestDupNaBusy: false,
      requestDupNiBusy: false,
      requestDupBnBusy: false,

      exclude_tag: false,

      dupMsTabs: [
        {
          id: 0,
          name: "USERS",
          alias: "USERS"
        },
        {
          id: 1,
          name: "NR",
          alias: "NA"
        },
        {
          id: 2,
          name: "NI",
          alias: "NI"
        },
        {
          id: 3,
          name: "BN",
          alias: "BN"
        },
        {
          id: 4,
          name: "NAAR",
          alias: "NAAR"
        }
      ],
      selectedDupMsTab: "USERS",

      naStatuses: [
        {
          id: 0,
          name: "No Answer"
        }
        /*        {
                      id:1,
                      name:'No Answer(Voice Mail)'
                    }*/
      ]
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  watch: {
    searchTagQuery: function() {
      this.result = this.filterList(this.searchTagQuery);
      if (this.result.length > 1) {
        this.showResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showResults = false;
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        alert();

        this.selectedUsers = [];
        this.exclude_tag = false;
      }
    },
    selectedUsers: function() {
      this.$emit("dup_users", this.selectedUsers);
    },
    selectedNa: function() {
      this.$emit("dup_na", this.selectedNa);
    },
    selectedNi: function() {
      this.$emit("dup_ni", this.selectedNi);
    },
    selectedBn: function() {
      this.$emit("dup_bn", this.selectedBn);
    },
    selectedNAAR: function() {
      this.$emit("dup_na_ar", this.selectedNAAR);
    },
    open: function() {
      if (this.open) {
        this.fetchUsersStats();
      }
    },
    initiatedFiltering() {
      if (this.initiatedFiltering && this.dupUsersStats.length > 0) {
        this.dupUsersStats = [];
      }
      if (this.open) {
        if (this.selectedDupMsTab === "USERS") {
          this.fetchUsersStats();
        }
        if (this.selectedDupMsTab === "NA") {
          this.fetchNaStats();
        }
        if (this.selectedDupMsTab === "NI") {
          this.fetchNiStats();
        }
        if (this.selectedDupMsTab === "BN") {
          this.fetchBnStats();
        }
        if (this.selectedDupMsTab === "NAAR") {
          this.fetchNAARStats();
        }
      }
    },
    exclude_tag: function() {
      this.$emit("exclude_tag", this.exclude_tag);

      /*      if (this.exclude_tag) {
                            this.closeSelect();
                          }*/
    },
    selectedDupMsTab: function() {
      if (this.selectedDupMsTab === "USERS") {
        this.fetchUsersStats();
      }
      if (this.selectedDupMsTab === "NA") {
        this.fetchNaStats();
      }
      if (this.selectedDupMsTab === "NI") {
        this.fetchNiStats();
      }
      if (this.selectedDupMsTab === "BN") {
        this.fetchBnStats();
      }
      if (this.selectedDupMsTab === "NAAR") {
        this.fetchNAARStats();
      }
    }
  },

  methods: {
    applyFilter() {
      this.$emit("dup_users", this.selectedUsers);
      this.$emit("dup_na", this.selectedNa);
      this.$emit("dup_ni", this.selectedNi);
      this.$emit("dup_bn", this.selectedBn);
      this.$emit("dup_na_ar", this.selectedNAAR);
      this.$emit("apply");
    },

    fetchUsersStats() {
      if (!this.requestDupUsersBusy && this.queryObject.hasOwnProperty("dup")) {
        this.requestDupUsersBusy = true;
        const id = this.dupUsersStats.length;
        apiClientCreator(`client/stats/tag/dup/users`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.dupUsersStats = res.data;
            this.requestDupUsersBusy = false;
          })
          .catch(err => {
            this.requestDupUsersBusy = false;
          });
      }
    },

    fetchNaStats() {
      if (!this.requestDupNaBusy && this.queryObject.hasOwnProperty("dup")) {
        this.requestDupNaBusy = true;
        apiClientCreator(`client/stats/tag/dup/na`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.dupNaStats = res.data;
            this.requestDupNaBusy = false;
          })
          .catch(err => {
            this.requestDupNaBusy = false;
          });
      }
    },

    fetchNiStats() {
      if (!this.requestDupNiBusy && this.queryObject.hasOwnProperty("dup")) {
        this.requestDupNiBusy = true;
        apiClientCreator(`client/stats/tag/dup/ni`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.dupNiStats = res.data;
            this.requestDupNiBusy = false;
          })
          .catch(err => {
            this.requestDupNiBusy = false;
          });
      }
    },

    fetchBnStats() {
      if (!this.requestDupBnBusy && this.queryObject.hasOwnProperty("dup")) {
        this.requestDupBnBusy = true;
        apiClientCreator(`client/stats/tag/dup/bn`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.dupBnStats = res.data;
            this.requestDupBnBusy = false;
          })
          .catch(err => {
            this.requestDupBnBusy = false;
          });
      }
    },
    fetchNAARStats() {
      if (!this.requestDupNAARBusy && this.queryObject.hasOwnProperty("dup")) {
        this.requestDupNAARBusy = true;
        apiClientCreator(`client/stats/tag/dup/na_ar`)
          .get("", { params: this.queryObject })
          .then(res => {
            this.dupNAARStats = res.data;
            this.requestDupNAARBusy = false;
          })
          .catch(err => {
            this.requestDupNAARBusy = false;
          });
      }
    },

    filterOptions() {
      return this.salesPersonList.filter(
        item => this.getStats(item.id).count !== 0
      );
    },

    niFilterOptions() {
      return this.dictionaries.activity.not_int_states.filter(
        item => this.getNiStats(item.id).count !== 0
      );
    },
    bnFilterOptions() {
      return this.dictionaries.activity.bad_number_states.filter(
        item => this.getBnStats(item.id).count !== 0
      );
    },
    getStats(i) {
      const stat = this.dupUsersStats.find(item => item.user_id === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },

    getNiStats(i) {
      const stat = this.dupNiStats.find(item => item.status_id === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },
    getBnStats(i) {
      const stat = this.dupBnStats.find(item => item.status_id === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },
    checkSelectAll: function() {
      this.selectedUsers = [];
      let person;
      if (!this.selectAll) {
        for (person in this.salesPersonList) {
          this.selectedUsers.push(this.salesPersonList[person]);
        }
      }
      this.selectAll = !this.selectAll;
    },

    closeSelect() {
      this.$emit("close");
    },

    resetSelect() {
      this.selectedUsers = [];
      this.selectAll = false;
      this.exclude_tag = false;
      this.$emit("close");
      this.$emit("reset");
    }
  }
};
</script>

<style scoped>
.root {
  position: absolute;
  top: 130px;
  left: -268px;
  width: 260px;
  z-index: 10001;

  padding: 5px;
  background-color: #fff;
  border: solid 1px #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  font-family: Montserrat;
}

.scroller-div {
  height: auto;
  max-height: 300px;
  overflow-x: hidden;
}

ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
  cursor: pointer;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.item-counter {
  font-size: 8pt;
  font-weight: bolder !important;
  margin-left: 10px;
  float: right;
  text-align: right;
}

.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}

.input-main {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 4px;
  border: 0.1px solid #fff4f4;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}

input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
                margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.loader-bottom {
  position: absolute;
  bottom: -5px;
  left: 50%;
}

.bttn-tab {
  width: max-content;
  margin-top: 0.3rem;
  margin-left: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 10px;
  font-family: inherit;
  cursor: pointer;
  height: 22px;
}

.multi-check-label {
  display: block;
  padding-left: 0.3rem;
  margin-right: 0.2rem;
  margin-left: 1.5rem;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}

.multi-check {
  width: 13px;
  height: 13px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}

.top-check-div {
  display: inline-flex;
}

.top-check-div {
  display: inline-flex;
}

.item-counter-text {
  color: white;
  width: 100%;
  background: #44a2d2;
  padding: 1px 3px 1px 3px;
  border-radius: inherit;
}

.nav {
  height: 20px;
  margin-top: 3px;
  margin-bottom: 5px;
}

.nav-tabs a {
  height: 20px;
  padding: 5px;
  font-size: 8pt;
}

.nav-tabs a:hover {
  background: #eceff1;
}

.nav-tabs li.active {
  border-top-color: transparent !important;
  border-bottom: 2px solid;
  border-bottom-color: #1e88e5;
  font-size: 10pt;
  font-weight: bold;
  color: #1e88e5;
}

.nav-tabs li {
  margin: 0px;
}

.nav-tabs li:hover {
  background: none;
  margin: 0;
}
</style>
